import ReactDOM from 'react-dom/client';
import { reportWebVitals } from './reportWebVitals';
import { App } from './App/App';
import React from 'react';

if (process.env.NODE_ENV === 'development') 
{
    import('./tests/TestRunner').then(function(tr)
    {
        import('./tests/AllTests');
    })
}

const rootElm = document.getElementById('root') as HTMLDivElement;
const root = ReactDOM.createRoot(rootElm);
root.render(<App/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();